import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';

export const getInitialState = () => ({
  currentForm: null,
  formSourceFields: [],
  isFormSourceFieldLoading: false,
  formFieldMappings: {},
  prevFormFieldMappings: {},
  formFieldMappingRowError: {},
  isSaveFormFieldMappingLoading: {},
  isCreateDefaultFormFieldMappingsLoading: false
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
